import type { SVGProps } from 'react';

const Knife = (props?: SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.812 10.4167L11.2253 12.8333L12.8333 11.222L10.4207 8.80532M8.812 10.4167L10.4207 8.80532M8.812 10.4167L7.204 12.028L4.296 9.11466C3.57307 8.39165 3.16693 7.41109 3.16693 6.38866C3.16693 5.36622 3.57307 4.38566 4.296 3.66266L4.79133 3.16666L10.4207 8.80532"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Knife;
